// extracted by mini-css-extract-plugin
module.exports = {"close_icon":"Contents_close_icon_3W2Gn"};